import { baseUrl_SPB } from '../../BaseUrl';

export default async function FetchBusinessCustomers(token) {
  const tokenValue = token ? token.toString() : '';
  const response = await fetch(`${baseUrl_SPB}/api/v1/businesscustomers/getcustomers`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + tokenValue,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch customers (${response.status})`);
  }

  return response.json();
}